module.exports = __webpack_public_path__ + "img/illus-side-kick.993850bb.png";